// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vbtn[data-v-00a3c922]{text-transform:none!important}.gradient-text[data-v-00a3c922]{background:-webkit-linear-gradient(#6c2bc2,#b32b6a);-webkit-background-clip:text;-webkit-text-fill-color:transparent}.search-bar[data-v-00a3c922]{min-width:200px;max-width:500px}.logoWidth[data-v-00a3c922]{width:90px}@media only screen and (min-width:1500px){.search-bar[data-v-00a3c922]{width:500px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
